/* 
  
  MF Simulator: Intermediate
  
*/

import React, { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation, Trans } from 'react-i18next';
import { trackPageView } from '../utils/analytics';

const Intermediate = (props) => {

  const { i18n } = useTranslation();
  const navigate = useNavigate(); // Get the navigate function from React Router

  // Detect the language before render
  // useLayoutEffect will block render until complete so be careful
  useLayoutEffect(() => {
    // Set the language
    i18n.changeLanguage(props.lan);
  }, [i18n, props.lan]);

  // Track page view when component mounts or language changes
  useEffect(() => {
    trackPageView(props.hreflang);
  }, [props.hreflang]);

  useEffect(() => {
    // Media query to check for landscape orientation
    const mediaQuery = window.matchMedia("(orientation: landscape)");

    const handleOrientationChange = (e) => {
      if (e.matches) {
        // If it's landscape mode, redirect to the proper language simulator page
        navigate(`/${props.hreflang}/simulator`);
      }
    };

    // 1. Initial check on load
    if (mediaQuery.matches) {
      navigate(`/${props.hreflang}/simulator`);
    }

    // 2. Add listener for orientation changes
    mediaQuery.addEventListener("change", handleOrientationChange);

    // 3. Cleanup function: important for preventing memory leaks
    return () => {
      mediaQuery.removeEventListener("change", handleOrientationChange);
    };
  }, [navigate, props.hreflang]);

  return(
    <div className={`d-flex flex-column align-items-center justify-content-center vh-100 bgblue position-relative text-white lang-${props.lan}`}>
      <div className="orientation-container text-center">
        <FontAwesomeIcon icon={['fas', 'fa-refresh']} className="orientation-icon" />
        <h1 className="orientation-title"><Trans i18nKey="orientation.h1" /></h1>
        <p className="orientation-unlock"><Trans i18nKey="orientation.unlock" /></p>
      </div>
    </div>
  )
}

export default Intermediate;